import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../../data/bonuses';
export function BonusesSection() {
  return <section className="bg-ink px-5 py-20 md:py-28" data-id="element-56" data-mp="15arpb78jken8">
      <div className="mx-auto max-w-6xl" data-id="element-57" data-mp="qcz727bm1c5c">
        <div className="text-center" data-id="element-58" data-mp="qe0tt91znn2w">
          <p className="text-xl font-semibold text-neutral-300 md:text-2xl" data-id="element-59" data-mp="qf3mnmivfzlg">Y para que no tengas que crear las herramientas...</p>
          <h2 className="mt-3 font-display text-3xl font-black uppercase leading-tight text-cream md:text-5xl" data-id="element-60" data-mp="1j0v5bggtvc48">
            Sumamos <span className="text-gold" data-id="element-61" data-mp="1nz6c1ibtt6i8">5 bonos prácticos.</span>
          </h2>
          <div className="mx-auto mt-6 h-0.5 w-16 bg-gold" aria-hidden="true" data-id="element-62" data-mp="19cd6v5w0th3r" />
        </div>

        <ul className="mt-14 flex flex-wrap justify-center gap-5" data-id="element-63" data-mp="1ea69joy47sza">
          {bonuses.map(b => <li key={b.label} className="flex w-full flex-col rounded-3xl border border-gold/40 bg-ink-soft p-7 sm:w-[calc(50%-0.625rem)] lg:w-[calc(33.333%-0.84rem)]" data-id="element-64" data-mp="220it5x2q3e5p">
              <div className="flex items-center gap-2.5" data-id="element-65" data-mp="26t24endxtx7c">
                <GiftIcon className="h-5 w-5 text-gold" aria-hidden="true" data-id="element-66" data-mp="2m6k2hpl1uu96" />
                <p className="font-display text-sm font-extrabold uppercase tracking-widest text-gold" data-id="element-67" data-mp="2h6xp9g581e0d">{b.label}</p>
              </div>
              <h3 className="mt-3 font-display text-xl font-black uppercase leading-tight text-cream md:text-2xl" data-id="element-68" data-mp="2vw3lcv8rio41">{b.title}</h3>
              <p className="mt-3 text-base leading-relaxed text-neutral-400 md:text-lg" data-id="element-69" data-mp="2r2il0wjp5i1o">{b.body}</p>
              <p className="mt-auto pt-5" data-id="element-70" data-mp="34y32ronovu7i">
                <span className="block border-t border-gold/25 pt-4 font-display text-xs font-extrabold uppercase tracking-wide text-gold-light md:text-sm" data-id="element-71" data-mp="2zxouq6m38k9h">
                  {b.highlight}
                </span>
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}